<template>
  <BLayoutExpansion title="Основное" class="my-4">
    <v-row dense>
      <v-col md="8" lg="6">
        <BTextarea
          v-model="form.long_name"
          validate="required"
          label="Полное наименование"
          :disabled="isView"
          :skeleton="skeleton"
          rows="2"
          name="long_name"
          autofocus
          counter
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col md="8" lg="6">
        <BTextarea
          v-model="form.short_name"
          validate="required"
          label="Краткое наименование"
          :disabled="isView"
          :skeleton="skeleton"
          rows="2"
          name="short_name"
          autofocus
          counter
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col md="8" lg="6">
        <BTextarea
          v-model="form.region_name"
          validate="required"
          label="Регион"
          :disabled="isView"
          :skeleton="skeleton"
          rows="2"
          name="region"
          autofocus
          counter
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col md="8" lg="6">
        <BTextarea
          v-model="form.municipality_name"
          validate="required"
          label="Муниципалитет"
          :disabled="isView"
          :skeleton="skeleton"
          rows="2"
          name="municipality"
          autofocus
          counter
        />
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col md="10" lg="8" />
    </v-row>

    <v-row v-if="!isCreate" dense>
      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          :value="data.created_at | dateFormatter"
          :skeleton="skeleton"
          label="Создан"
          disabled
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          :value="data.updated_at | dateFormatter"
          :skeleton="skeleton"
          label="Обновлен"
          disabled
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          :value="status"
          :skeleton="skeleton"
          label="Статус"
          disabled
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          :value="data.is_active ? 'Активный' : 'Не активный'"
          :skeleton="skeleton"
          label="Состояние"
          disabled
        />
      </v-col>
    </v-row>

    <slot name="save-menu" />
  </BLayoutExpansion>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'
import { PassportStatus } from '@/typings/api/PassportList'
import { PassportTemplateType } from '@/typings/api/Passport'

export default {
  name: 'PassportMain',
  components: {
    BLayoutExpansion,
    BTextField,
    BTextarea,
  },
  props: {
    skeleton: Boolean,
    disabled: Boolean,
    isCreate: Boolean,
    isView: Boolean,
    form: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    ateTypes: Object.values(PassportTemplateType).map((value) => {
      let label
      switch (value) {
        case PassportTemplateType.SCHOOL:
          label = 'ОО'
          break
        case PassportTemplateType.MUNICIPALITY:
          label = 'Муниципалитет'
          break
        case PassportTemplateType.REGION:
          label = 'Регион'
          break
        default:
          label = '---'
      }
      return { label, value }
    }),
  }),
  computed: {
    status() {
      switch (this.data.status) {
        case PassportStatus.notStarted:
          return 'Не приступал'
        case PassportStatus.inProgress:
          return 'В работе'
        case PassportStatus.submitted:
          return 'Сдано'
        default:
          return ''
      }
    },
  },
}
</script>
